import { Card } from '../../../../components/ui/card';
import { Skeleton } from '../../../../components/ui/skeleton';
import { cn } from '../../../../lib/utils';
type CategoryProps = {
  shrunk?: boolean;
};

export const CategoryCardSkeleton = ({ shrunk = false }: CategoryProps) => {
  return (
    <Card
      className={cn(
        'bg-fill-base shadow-none flex flex-col   border-none  items-center justify-center transition-all duration-500 ease-in-out',
        {
          'min-h-[96px] min-w-[96px] px-2 pb-1 rounded-2xl': !shrunk,
          'min-h-[32px] min-w-[96px]  items-center justify-center': shrunk,
        }
      )}
    >
      <Skeleton
        className={cn(
          ' object-contain transition-all duration-500 ease-in-out',
          {
            'w-0 h-0  opacity-0': shrunk,
            'w-[72px] h-[72px] opacity-100': !shrunk,
          }
        )}
      />
      <Skeleton className="text-caption-sm-medium text-text-primary" />
    </Card>
  );
};
